import { Injectable } from '@angular/core';
import { AdminNote } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AdminNotesService {
    constructor(private http: HttpClient) { }

    public create(note: AdminNote): Observable<AdminNote> {
        return this.http.post<AdminNote>('api/adminnotes/create', note);
    }

    public delete(notedId: number): Observable<void> {
        return this.http.delete<void>('api/adminnotes/delete/' + notedId);
    }
}